import React from 'react';
import { useNavigate } from 'react-router-dom';

const ChatHeader = ({
    productDetailsLoaded,
    productName,
    productPrice,
    productCurrency,
    productId,
    chatPartnerDetails,
    chatPartnerId,
    userColors,
    profileTargetId,
    isCurrentUser,
    onReportUser
}) => {
    const navigate = useNavigate();

    const ProductHeaderSkeleton = () => (
        <div className="chat-header">
            <div className="chat-product">
                <div className="chat-product__name skeleton-shimmer" style={{
                    width: '200px',
                    height: '20px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div className="shimmer-effect"></div>
                </div>
                <div className="chat-product__price skeleton-shimmer" style={{
                    width: '100px',
                    height: '16px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    marginTop: '8px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div className="shimmer-effect"></div>
                </div>
                <div className="skeleton-shimmer" style={{
                    width: '150px',
                    height: '12px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    marginTop: '6px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div className="shimmer-effect"></div>
                </div>
            </div>
            <div className="chat-owner">
                <div className="chat-owner__avatar skeleton-shimmer" style={{
                    width: '44px',
                    height: '44px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '50%',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div className="shimmer-effect"></div>
                </div>
                <div className="skeleton-shimmer" style={{
                    width: '80px',
                    height: '12px',
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                    marginTop: '4px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div className="shimmer-effect"></div>
                </div>
            </div>
        </div>
    );

    if (!productDetailsLoaded && !productName) {
        return <ProductHeaderSkeleton />;
    }

    return (
        <div className="wzc-header">
            <div className="chat-product">
                <div
                    className="chat-product__name"
                    onClick={() => navigate(`/products/view/${productId}`)}
                    title="Cliquez pour voir les détails du produit"
                    style={{ cursor: 'pointer' }}
                >
                    {productName || 'Produit'}
                </div>
                <div className="chat-product__price">
                    <span className="price-amount">{productPrice || '0'}</span>
                    <span className="chat-product__currency"> {productCurrency || 'CDF'}</span>
                </div>
                {productDetailsLoaded && (
                    <div className="chat-product__meta">
                        <small className="text-muted">Discussion sur ce produit</small>
                    </div>
                )}
            </div>
            {chatPartnerDetails && (
                <div className="chat-owner">
                    {chatPartnerDetails.profile_picture ? (
                        <img
                            src={chatPartnerDetails.profile_picture}
                            alt="Owner Profile"
                            className="chat-owner__avatar"
                        />
                    ) : (
                        <div
                            className="chat-owner__initials"
                            style={{ backgroundColor: (chatPartnerId && userColors[chatPartnerId]) || '#003366' }}
                        >
                            {(chatPartnerDetails.first_name || chatPartnerDetails.username || 'U')[0] || 'U'}
                            {(chatPartnerDetails.last_name || chatPartnerDetails.username || 'U')[0] || 'U'}
                        </div>
                    )}
                    <div className="chat-owner__details">
                        <span className="chat-owner__name">
                            {`${chatPartnerDetails.first_name || ''} ${chatPartnerDetails.last_name || ''}`.trim() || chatPartnerDetails.username || 'Utilisateur'}
                        </span>
                        {chatPartnerDetails.mobile_number ? (
                            <a
                                href={`tel:${chatPartnerDetails.mobile_number}`}
                                className="chat-owner__contact chat-owner__contact-phone"
                                title="Appeler ce numéro"
                            >
                                📞 {chatPartnerDetails.mobile_number}
                            </a>
                        ) : (
                            <span className="chat-owner__contact">
                                {chatPartnerDetails.email || 'Numéro non renseigné'}
                            </span>
                        )}
                        <span
                            className="chat-owner__username chat-owner__username-link"
                            onClick={() => {
                                if (profileTargetId && profileTargetId !== 'undefined') {
                                    navigate(`/user/corner/${profileTargetId}`);
                                } else {
                                    console.error('Cannot navigate: no valid user ID found');
                                }
                            }}
                            title="Voir le profil utilisateur"
                        >
                            {`${chatPartnerDetails.first_name || ''} ${chatPartnerDetails.last_name || ''}`.trim() || 'utilisateur'}
                        </span>
                    </div>
                </div>
            )}

            {/* Report User Button */}
            {chatPartnerDetails && !isCurrentUser(chatPartnerId) && (
                <button
                    className="chat-report-button"
                    onClick={onReportUser}
                >
                    Signaler
                </button>
            )}
        </div>
    );
};

export default ChatHeader;